import React from 'react';
import ReactGA from 'react-ga';
import Helmet from 'react-helmet';
import Favicon from 'react-favicon';

import {connects} from '@gisatcz/ptr-state';
import Action from "./state/Action";
import config from './config';
import favicon from './assets/favicon.ico';

// base styles need to be imported before all components
import '@gisatcz/ptr-core/lib/styles/reset.css';
import '@gisatcz/ptr-core/lib/styles/base.scss';
import './styles/index.scss';

import {AppContainer} from '@gisatcz/ptr-components';

import {create as createRouter} from '@gisatcz/ptr-router';
import {init as initCore} from './core';
import App from "./components/App";

// TODO load from BE
import configurationData from "./data/configuration";
import viewData from "./data/view";
import {
	riskAssessmentZonesBig,
	riskAssessmentZonesSmall,
	interferometryPointsBig,
	interferometryPointsSmall,
	interferometryZonesBig,
	interferometryZonesSmall, riskAssessmentRoadsBig, riskAssessmentRoadsSmall,
} from './data/layers/vectorLayers';

const path = process.env.PUBLIC_URL;

function createRoutes(Store) {
	return {
		'': {
			name: 'homepage',
			handler: function (request) {

			},
		},
	};
}

function init(Store, {absPath, isPreloaded, currentUrl, navHandler}) {
	ReactGA.initialize('UA-59584085-10');
	/**
	 * Creates router instance that can be used to manipulat urls.
	 *
	 * App handler updates store with current page and it's up to views to react to the change.
	 * In case of url change, redux selector possibly retrieves different data and passes them
	 * into some the component.
	 *
	 */
	const router = createRouter({
		rootUrl: absPath,
		currentUrl,
		routes: createRoutes(Store),
		navHandler,
	});

	initCore({router});

	if (isPreloaded) {
		return;
	}

	Store.dispatch(Action.app.updateLocalConfiguration(config));
	Store.dispatch(Action.app.setKey('eo4sdDrrInsarMyanmar20'));
	Store.dispatch(Action.app.setBaseUrl(path));
	ReactGA.pageview(path);

	/* Add configuration */
	Store.dispatch(Action.app.setLocalConfiguration('data', configurationData));

	/* Add & apply views */
	Store.dispatch(Action.views.add(viewData));
	Store.dispatch(Action.components.updateStateFromView(viewData?.data?.state?.components));
	Store.dispatch(Action.maps.updateStateFromView(viewData?.data?.state?.maps));
	Store.dispatch(Action.selections.updateStateFromViewWithData(viewData?.data?.state?.selections));
	Store.dispatch(Action.styles.updateStateFromViewWithData(viewData?.data?.state?.styles));

	/* Add vector layers */
	Store.dispatch(Action.maps.addMapLayers('risk-assessment-big', [riskAssessmentZonesBig, riskAssessmentRoadsBig]));
	Store.dispatch(Action.maps.addMapLayers('risk-assessment-small', [riskAssessmentZonesSmall, riskAssessmentRoadsSmall]));
	Store.dispatch(Action.maps.addMapLayers('interferometry-big', [interferometryZonesBig, interferometryPointsBig]));
	Store.dispatch(Action.maps.addMapLayers('interferometry-small', [interferometryZonesSmall, interferometryPointsSmall]));
}

const ConnectedAppContainer = connects.AppContainer(AppContainer);

const AppComponent = () => {
	return (
		<>
			<Favicon url={favicon} />
			<Helmet defaultTitle="EO4SD Insar Myanmar" />
			<ConnectedAppContainer appKey="eo4sdDrrInsarMyanmar20">
				<App/>
			</ConnectedAppContainer>
		</>
	);
};

export {AppComponent as App, init};
